import { getACHAuthorizationRecords } from './GetACHAuthorizationRecords';
import { revokeACHAuthorization } from './RevokeACHAuthorization';
import { downloadACHAuthorizationRecord } from './DownloadACHAuthorizationRecord';

export const PaymentsApi = {
  getACHAuthorizationRecords,
  revokeACHAuthorization,
  downloadACHAuthorizationRecord,
};
